import { useContext, useMemo } from "react";
import { GeaoContext } from "../../../GeaoContextProvider";

export default function useMappers(formData) {
    const { agencyInterview } = useContext(GeaoContext);

    const defaultValues = useMemo(() => {
        const q = agencyInterview?.questionAnswers || {};

        // Translate stored single value ("AGY", "PROD", "BOTH") into checkbox array
        const contactAnswer = q.IncentiveProgramsContact?.answer;
        let incentiveContact = [];

        if (contactAnswer === "BOTH") {
            incentiveContact = ["AGY", "PROD"];
        }
        else if (contactAnswer === "AGY" || contactAnswer === "PROD") {
            incentiveContact = [contactAnswer];
        }

        return {
            incentiveParticipation: q.ParticipateInIncentivePrograms?.answer ?? "",
            incentiveContact,
            referralSource: q.HearAboutOpportunity?.answer ?? "",
            agencyWebsite: q.AgencyWebsite?.answer ?? "",
            agencyFacebook: q.AgencyFacebookHandle?.answer ?? "",
            agencyInstagram: q.AgencyInstagramHandle?.answer ?? "",
        };
    }, [agencyInterview]);

    const agencyAnswers = useMemo(() => {
        if (!formData) return null;

        let incentiveContactAnswer = "";

        if (formData.incentiveContact?.length === 2) {
            incentiveContactAnswer = "BOTH";
        } else if (formData.incentiveContact?.length === 1) {
            incentiveContactAnswer = formData.incentiveContact[0];
        }

        const participatesInIncentives = formData.incentiveParticipation === "true";

        return {
            ParticipateInIncentivePrograms: { answer: formData.incentiveParticipation ?? "false" },
            IncentiveProgramsContact: { answer: participatesInIncentives ? incentiveContactAnswer : "" },
            HearAboutOpportunity: { answer: participatesInIncentives ? (formData.referralSource ?? "") : "" },
            ...(participatesInIncentives && formData.agencyWebsite ? { AgencyWebsite: { answer: formData.agencyWebsite } } : {}),
            ...(participatesInIncentives && formData.agencyFacebook ? { AgencyFacebookHandle: { answer: formData.agencyFacebook } } : {}),
            ...(participatesInIncentives && formData.agencyInstagram ? { AgencyInstagramHandle: { answer: formData.agencyInstagram } } : {})
        };
    }, [formData]);

    return {
        defaultValues,
        agencyAnswers
    };
}

